import * as Sentry from '@sentry/react';

export const buildSentryLogger = () => {
  const error = (e, tags = {}) => {
    if (!Sentry?.captureException) return; // Wait to be instantiated
    Sentry.captureException(e, { tags });
  };

  const setUser = (data = {}) => {
    if (!Sentry?.setUser) return; // Wait to be instantiated
    Sentry.setUser(data);
  };

  const setContext = (contextName, data = {}) => {
    if (!Sentry?.setContext) return; // Wait to be instantiated
    Sentry.setContext(contextName, data);
  };

  const addBreadcrumb = (params = {}) => {
    if (!Sentry?.addBreadcrumb) return; // Wait to be instantiated
    Sentry.addBreadcrumb({
      type: params?.type,
      category: params?.category,
      data: params?.data || {},
      level: params?.level || 'info',
      message: params?.message || '',
    });
  };

  return {
    error,
    setUser,
    setContext,
    addBreadcrumb,
  };
};
